import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ExpandedOption } from '@/modules/HealthPlan/queries/usePlansByPlanYear.query.ts';
import ModuleWrapper from '@/modules/plan/ModuleWrapper';

import { HEALTH_PLAN_MODULES } from '../../HealthPlan.constants';

import Additional from './Additional';
import HealthPlanName from './HealthPlanName';
// import { usePreviewStore } from '../stores';
import PlanYear from './PlanYear';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isHealthPlanActive?: boolean;
  arePlansEditable?: boolean;
  onDirty?: (isDirty: boolean) => void;
  planYearFormatedOptions?: ExpandedOption[];
}

const BasicProperties: React.FC<Props> = ({
  isEditMode,
  isTemplateMode,
  isHealthPlanActive,
  arePlansEditable,
  onDirty,
  planYearFormatedOptions,
}) => (
  // const previewMode = usePreviewStore((state) => state.previewMode);
  <ModuleWrapper
    testId="basic-properties-wrapper"
    anchorId={HEALTH_PLAN_MODULES.BASIC_PROPERTIES}
    title="Basic Properties"
    expandless
  >
    <>
      <HealthPlanName
        isEditMode={isEditMode}
        isTemplateMode={isTemplateMode}
        arePlansEditable={arePlansEditable}
        onDirty={onDirty}
      />
      {isTemplateMode ? null : (
        <Box data-testid="basic-properties-year" margin={{ top: 'spacing24' }}>
          <PlanYear onDirty={onDirty} />
        </Box>
      )}
      {isTemplateMode ? null : (
        <Box data-testid="additional-section" margin={{ top: 'spacing24' }}>
          <Additional
            isEditMode={isEditMode}
            isHealthPlanActive={isHealthPlanActive}
            onDirty={onDirty}
            isTemplateMode={isTemplateMode}
            arePlansEditable={arePlansEditable}
            planYearFormatedOptions={planYearFormatedOptions}
          />
        </Box>
      )}
    </>
  </ModuleWrapper>
);

export default BasicProperties;
